import { send_request } from "../../../utils/Request";
import {
  extractApiErrorMessage,
  isFailedRequest,
} from "../../../utils/apiErrorMessage";

// Tenant-authored mission template CRUD (plan 2 Phase 5). Reads are open to any tenant user; writes
// are admin/owner only (enforced at the workflow-engine proxy — the UI mirrors that gating).
const BASE = "project-service/agent/mission-templates";

// send_request resolves (does not throw) on HTTP failure, so every caller must inspect the
// resolved value. These wrappers throw on failure so page-level error paths work; callers that
// prefer a silent empty fallback catch it themselves.
export async function listMissionTemplates() {
  const response = await send_request(BASE, "", {}, "GET");
  if (isFailedRequest(response)) {
    throw new Error(
      extractApiErrorMessage(response, "Failed to load mission templates")
    );
  }
  return Array.isArray(response?.data) ? response.data : [];
}

export async function createMissionTemplate(body) {
  const response = await send_request(BASE, body, {}, "POST");
  if (isFailedRequest(response)) {
    throw new Error(
      extractApiErrorMessage(response, "Failed to create mission template")
    );
  }
  return response?.data || null;
}

export async function updateMissionTemplate(id, body) {
  const response = await send_request(`${BASE}/${id}`, body, {}, "PUT");
  if (isFailedRequest(response)) {
    throw new Error(
      extractApiErrorMessage(response, "Failed to update mission template")
    );
  }
  return response?.data || null;
}

export async function deleteMissionTemplate(id) {
  const response = await send_request(`${BASE}/${id}`, "", {}, "DELETE");
  if (isFailedRequest(response)) {
    throw new Error(
      extractApiErrorMessage(response, "Failed to delete mission template")
    );
  }
}

/** True when the current user is an administrator or owner (mirrors the proxy write gate). */
export async function fetchIsTemplateAdmin() {
  try {
    const response = await send_request("authz-service/user-info", "", "", "GET");
    return Boolean(response?.data?.roleAdministrator || response?.data?.roleOwner);
  } catch {
    return false;
  }
}
